import React, { Component} from 'react';
import { Modal, Button } from 'react-bootstrap';
import Fetch from '../Components/Fetch';
import Auth from '../Auth/Auth';
import ContentProvider from '../Providers/ContentProvider';

import LoadingProfilePreferences from '../Auth/LoadingProfilePreferences';

import { toast } from 'react-toastify';
import chromeIcon from '../images/BrowserIcons/chrome.png';
import mozillaIcon from '../images/BrowserIcons/mozilla.png';
import operaIcon from '../images/BrowserIcons/opera.png';
import safariIcon from '../images/BrowserIcons/safari.png';

const auth = new Auth();


//If IE then show a toaster Icon to display better experience with other browser
let ua = navigator.userAgent;
let is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

class FetchContainer extends Component {
  constructor(props){
    super(props);

    this.state = {
      show : false,
      darkmode : false,
      initResultPage: false,
      defaultSmartPanelTab: '',
      isReady: false
    };
  }

  async componentDidMount(){
      let accessToken;

      if(!await auth.getToken()){
        setTimeout(async function(){
          accessToken = await auth.getToken();
        },10000);
      } else {
        accessToken = await auth.getToken();
      }
  
      let userPreferences = JSON.parse(localStorage.getItem("userPreferences"));    
      if(localStorage.getItem("userPreferences") === null || (userPreferences.PreferenceStamp === undefined || userPreferences.PreferenceStamp < new Date(new Date().toLocaleDateString()).valueOf() ) ){        
        fetch('/api/getUserPreferences', {
          method : "GET",
          headers : {
              'Authorization': "Bearer " + accessToken,
              withCredentials : true,
              crossDomain: true,
          }
        }).then(response => {
          if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {
            if(data[0]){
              this.setState({
                initResultPage : data[0].HomeScreen === "Result Page",
                defaultSmartPanelTab: data[0].SmartPanelTab,
                darkmode: data[0].Theme === "Dark"
              });
              if(data[0].Theme === "Dark"){
                require('../App-Dark.scss');
              }
              data[0].PreferenceStamp = new Date(new Date().toLocaleDateString()).valueOf();
              localStorage.setItem("userPreferences",JSON.stringify(data[0]));
              this.setState({
                isReady: true
              });
            } else {
              sessionStorage.setItem("showUserPreferenceModal",true);
              this.setState({
                isReady: true
              });
            }       
        }).catch((error) => {
          console.error('Error:', error);
          this.setState({
            isReady: true
          });
        });
      } else {
        sessionStorage.removeItem("showUserPreferenceModal",true);
        this.setState({
          initResultPage : userPreferences.HomeScreen === "Result Page",
          defaultSmartPanelTab: userPreferences.SmartPanelTab,
          darkmode: userPreferences.Theme === "Dark",
          isReady: true
        });
        if(userPreferences.Theme === "Dark"){
          require('../App-Dark.scss');
        }
      }

    
  }

  handleClose(){
    this.setState({
      show : false
    });
  }

  isIEApproved(){
    var date = new Date();    
    localStorage.setItem("ie",JSON.stringify({ acknowledge : true, dateUntilNextShow: date.setDate(date.getDate() + 7) }));
    this.setState({
      show : false
    });
  }
  
  render(){
    return (
      <div className={this.state.darkmode ? "app-dark" : ""}>
      {!this.state.isReady && (
        <LoadingProfilePreferences />
      )}
      {this.state.isReady && (
        <ContentProvider>
          <Fetch initResultPage={this.state.initResultPage} defaultSmartPanelTab={this.state.defaultSmartPanelTab} darkmode={this.state.darkmode} />
        </ContentProvider>        
      )}        
      <Modal size="lg" show={this.state.show} onHide={() => this.handleClose()} >          
        <Modal.Body className="text-center">
          <h2>It looks like you are using IE</h2>
          <h5>For the best experience use one of the following:</h5>
          <div className="mb-5">
            <img width="10%" alt="Chrome Icon" src={chromeIcon} />
            <img width="10%" alt="Mozilla Icon" src={mozillaIcon} />
            <img width="10%" alt="Safari Icon" src={safariIcon} />
            <img width="10%" alt="Opera Icon" src={operaIcon} />
          </div>
          <h2>Internet Explorer is not fully supported</h2>
          <h5>If you find issue's please do not open a ticket but instead use one of the supported browsers above.</h5>
          <div>
            <Button onClick={() => this.isIEApproved()} style={{position : "absolute", bottom: "20px", right: "20px"}}>I understand. dont show me this again</Button>
          </div>
          
        </Modal.Body>
        
      </Modal>
    </div>     
      
    );
  }
}

export default FetchContainer;